"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));
var styles = {
  "loading": "Metrics__loading__26wnH",
  "metadata-item": "Metrics__metadata-item__h4SBP",
  "metadataItem": "Metrics__metadata-item__h4SBP",
  "engagement-metric": "Metrics__engagement-metric__1OsrL",
  "engagementMetric": "Metrics__engagement-metric__1OsrL",
  "metadata-item-wrapper": "Metrics__metadata-item-wrapper__1NpuO",
  "metadataItemWrapper": "Metrics__metadata-item-wrapper__1NpuO"
}; 
require('./Metrics.css');
var Loading = function Loading(_ref) {
  var testId = _ref.testId;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.loading,
    "data-test-id": testId
  }, /*#__PURE__*/_react.default.createElement(_reactContentLoader.default, {
    height: 18,
    viewBox: "0 0 50 18"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: 0,
    y: 0,
    rx: 3,
    ry: 3,
    width: 50,
    height: 18
  })));
};
var _default = exports.default = Loading;
//# sourceMappingURL=Loading.js.map